import { ICommonState } from '~/domain/common/types';
export default {
  isPageBusy: (state: ICommonState) => () => {
    return state.pageBusy
  },
  getHeroLoaded: (state: ICommonState) => state.heroLoaded,
  getErrorMessage: (state: ICommonState) => state.errorMessage,
}
